import script from "./DateFormatMixins.vue?vue&type=script&lang=js"
export * from "./DateFormatMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__